import React from 'react';
import styled from '@emotion/styled';
import { appStyles } from '../../../../styles';
import { UploadImage } from '../../../../assets';

export interface AttributeValues {
  backgroundImage?: string;
  textColor?: string;
  description?: string;
  title?: string;
  ctaText?: string;
  colorOpacity?: string;
  heading?: string;
  priceColor?: string;
  buttonBGColor?: string;
  buttonTextColor?: string;
}
interface PreviewProps {
  values: AttributeValues & any;
  isPreview?: boolean;
  height?: string;
  className?: string;
}

export const PreviewPartner = (props: PreviewProps) => {
  const { values, isPreview, height, className } = props;
  const { backgroundImage } = values;
  const isDefaultImage = backgroundImage === '' || !backgroundImage || !isPreview;

  return (
    <StyledPartnerPreview className={className} style={{ height: height || '300px', backgroundColor: '#fff' }}>
      <div>
        <div className="preview-ant-image">
          <StyledLinearGradient />
          {!isDefaultImage ? (
            <img className="image-partner" src={backgroundImage} alt="" />
          ) : (
            <div className="d-flex justify-content-center align-items-center">
              <img style={{ width: '3rem', height: '3rem' }} src={UploadImage} alt="" />
              <div style={{ fontSize: '15px' }}>* Upload Partner Logo</div>
            </div>
          )}
        </div>
      </div>
    </StyledPartnerPreview>
  );
};

const StyledLinearGradient = styled.div`
  ${appStyles.fullWidthHeight}
  ${appStyles.borderRadiusPreview}
  position: absolute;
`;

const StyledPartnerPreview = styled.div`
  margin: 2rem;
  position: relative;
  text-align: left;
  font-family: 'DIN Condensed Bold';
  line-height: 1.2;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  & .heading {
    font-size: 15px;
    padding: 0 1rem;
  }
  & .btn-learn-more {
    border-radius: 25px;
    margin: 0 0 0.5rem 0.5rem;
    width: 6rem;
    height: 2.3rem;
  }
  & .preview-ant-image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 0;
    height: 200px;
    & .image-partner {
      padding: 0;
      max-height: 3rem;
      width: auto;
    }
  }
  .wrapper-text-preview {
    position: absolute;
    bottom: 20%;
    width: 100%;
    padding: 0 1rem;
  }
  & .title {
    font-size: 25px;
  }
  & .priceColor {
    display: block;
    font-size: 11px;
  }
  .promotion-preview {
    & .description {
      font-size: 25px;
    }
    & .title {
      font-size: 14px;
    }
  }
  & .wrapper-btn-preview {
    position: absolute;
    bottom: 8px;
    width: 100%;
    display: flex;
    padding: 0 1rem;
    & .button {
      border-radius: 1rem;
      background: #fff;
      color: #000;
      height: 30px;
      font-size: 16px;
      padding: 0.2rem 1.25rem 0 1.25rem;
    }
  }

  @media screen and (max-width: 1440px) {
    .text-preview {
      bottom: 13%;
    }
    & .description {
      font-size: 12px;
    }
    & .title {
      font-size: 21px;
    }

    .promotion-preview {
      & .description {
        font-size: 21px;
      }
      & .title {
        font-size: 15px;
      }
    }
  }
`;
